import type { FC } from 'react';

interface VouchersProps {}

const Vouchers: FC<VouchersProps> = () => {
  return <div>vouchers</div>;
};

export default Vouchers;
